export default __webpack_public_path__ + "static/genova-1-2edc2518c636fd2feb6bcfa791c14ddf.jpg";